import script from "./TheFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheFooter.vue?vue&type=script&setup=true&lang=ts"

import "./TheFooter.vue?vue&type=style&index=0&id=1076e30a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1076e30a"]])

export default __exports__